import { InfoModalInterface } from '@modules/components-common';

export type TicketSelectorFieldMap<T extends string> = Record<
  T,
  InfoModalInterface
>;
